var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "15px",
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Moneygram10",
    transform: "translate(-624.000000, -734.000000)",
    fill: "#39890A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(458.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(18.000000, 366.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.129728,35.7851774 C166.949427,35.6672885 165.902297,34.6687009 164.806624,33.5591591 C163.704017,32.4496172 161.041117,29.8075207 158.89138,27.6785874 L154.97331,23.8159949 L152.421364,26.3193986 C151.020567,27.6924566 149.800071,28.8574756 149.709921,28.906018 C149.619771,28.9545605 149.383993,28.9961683 149.175954,29.0031029 C148.28832,29.0100376 147.71968,28.1016002 148.142693,27.3526594 C148.378471,26.9296466 154.12035,21.3125911 154.501755,21.1322906 C154.855421,20.9658593 155.112003,20.9589247 155.4518,21.0976174 C155.743055,21.2224408 168.676152,33.9960412 168.849517,34.3358383 C169.002079,34.6201584 168.981276,35.181864 168.80791,35.4661841 C168.468112,36.0278896 167.719172,36.1665824 167.129728,35.7851774 Z",
    id: "Path",
    transform: "translate(158.476027, 28.500000) scale(1, -1) translate(-158.476027, -28.500000) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.189348c793b276f725de5dc3fd51f837.svg";
export { ForwardRef as ReactComponent };